import { render, staticRenderFns } from "./On.vue?vue&type=template&id=10fa77b2&scoped=true"
import script from "./On.vue?vue&type=script&lang=js"
export * from "./On.vue?vue&type=script&lang=js"
import style0 from "./On.vue?vue&type=style&index=0&id=10fa77b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa77b2",
  null
  
)

export default component.exports